import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';
import {
  fetchCustomers,
  fetchLogisticLines,
  searchProducts,
  fetchPaymentStatus,
  addOrders,
} from '../services/ordersService';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from './ConfirmationModal';
import { showSuccessToast } from '../../../utils/toastHelper';
import { AsyncPaginate } from 'react-select-async-paginate';
import useDynamicInputWidth from '../hooks/useDynamicInputWidth';

const AddCateringModal = ({ setAddCateringModal, actionType, onSuccess }) => {
  const { t } = useTranslation('Order');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [tmrCheck, setTmrCheck] = useState(false);

  // State for each input field
  const [loader, setLoader] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState('');
  const [referenceNumber, setReferenceNumber] = useState('');
  const [poNumber, setPoNumber] = useState('');
  // const [deliveryAddress, setDeliveryAddress] = useState('');
  // const [area, setArea] = useState('');
  // const [district, setDistrict] = useState('');
  // const [contactPerson, setContactPerson] = useState('');
  // const [contactPhone, setContactPhone] = useState('');
  // const [paymentMethod, setPaymentMethod] = useState('');

  const [logisticLineManual, setManualLogisticLine] = useState({
    name: '',
    id: '',
  });

  const [paymentStatus, setPaymentStatus] = useState({ name: '', id: '' });

  const [paymentDate, setPaymentDate] = useState('');
  const [orderRemark, setOrderRemark] = useState('');

  const [customers, setCustomers] = useState([]);
  const [productInfo, setProductsInfo] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState({});

  const [products, setProducts] = useState([]);
  const dynamicSizeInputRefs = useRef([]);
  const specificationInputRefs = useRef([]);
  const productRemarkInputRefs = useRef([]);
  useDynamicInputWidth(dynamicSizeInputRefs, products);
  useDynamicInputWidth(
    specificationInputRefs,
    products,
    (item) => item.specification
  );
  useDynamicInputWidth(
    productRemarkInputRefs,
    products,
    (item) => item.productRemark
  );
  const handlePaymentStatusChange = (e) => {
    const selectedPaymentStatus = paymentOptions.find(
      (area) => area.name === e.target.value
    );
    setPaymentStatus({
      name: e.target.value,
      id: selectedPaymentStatus?.id || '',
    });
  };
  const handleLogisticLineChange = (e) => {
    const selectedLogisticLine = logisticLineOptions.find(
      (line) => line.name === e.target.value
    );
    setManualLogisticLine({
      name: e.target.value,
      id: selectedLogisticLine?.id || '',
    });
  };
  const toggleEdit = (index) => {
    const updatedProducts = [...products];
    updatedProducts[index].isEditing = !updatedProducts[index].isEditing;
    setProducts(updatedProducts);
  };

  const addProduct = () => {
    setProducts([
      ...products,
      {
        productCode: '',
        productName: '',
        origin: '',
        specification: '',
        quantity: '',
        // unitPrice: '',
        productRemark: '',
        processLocation: '',
        productId: '',
        isEditing: true,
      },
    ]);
  };

  const removeProduct = (index) => {
    const updatedProducts = products.filter((_, i) => i !== index);
    setProducts(updatedProducts);
  };

  useEffect(() => {
    // getCustomers();
    // getCustomerCodes();
    getPaymentStatus();
    getLogisticLine();
  }, []);
  const [paymentOptions, setPaymentOption] = useState([]);

  const getPaymentStatus = async () => {
    try {
      const response = await fetchPaymentStatus();
      setPaymentOption(response?.payment_statuses || []);
    } catch (error) {
      console.error('Error fetching areas:', error);
    }
  };
  const customersLoadOptions =
    (labelType = 'code') =>
    async (inputValue, loadedOptions, { page }) => {
      const per_page = 50;
      const query = {
        page,
        per_page,
        search: inputValue,
        category: 'catering',
      };

      const customersResponse = await fetchCustomers(query);

      setCustomers((prev) => [
        ...prev,
        ...(customersResponse?.customers || []),
      ]);

      const newOptions = customersResponse.customers?.map((customer) => ({
        value: customer.id,
        label: labelType === 'code' ? `${customer.code}` : `${customer.name}`,
      }));

      return {
        options: newOptions,
        hasMore:
          customersResponse.pagination.current_page <
          customersResponse.pagination.last_page,
        additional: {
          page: page + 1,
        },
      };
    };
  const handleCustomerCodeChange = (selectedOption) => {
    if (selectedOption) {
      // handleDropdownChange('customerCode', selectedOption.value); // Use customerCode

      const selectedCustomerElement = customers.find(
        (customer) => customer.id === selectedOption.value
      );
      if (selectedCustomerElement) {
        setSelectedCustomer(selectedCustomerElement);
        setManualLogisticLine({
          name: selectedCustomerElement?.logistic_line?.name,
          id: selectedCustomerElement?.logistic_line?.id,
        });
      }
    } else {
      // Clear the selection and reset related fields
      setSelectedCustomer({});
      // setDeliveryAddress(''); // Reset delivery address state
      // setArea(''); // Reset area state
      // setDistrict(''); // Reset district state
      setManualLogisticLine({ name: '', id: '' }); // Reset logistic line state
      // setContactPerson(''); // Reset contact person state
      // setContactPhone(''); // Reset contact phone state
      // setPaymentMethod(''); // Reset payment method state
    }
  };
  // Convert customers to the format required by react-select
  // const customerCodeOptions = customers.map((customer) => ({
  //   value: customer.code, // Use customer code as the value
  //   label: customer.code, // Use customer code as the label
  //   id: customer.id, // Additional data you might need (customer ID)
  // }));
  // const customerNameOptions = customers.map((customer) => ({
  //   value: customer.code, // Use customer code as the value
  //   label: customer.name, // Use customer code as the label
  //   id: customer.id, // Additional data you might need (customer ID)
  // }));
  const handleDropdownChange = (field, value) => {};
  // const getCustomers = async (groupId) => {
  //   try {
  //     const query = {
  //       category: 'catering',
  //       // search: searchQuery,
  //     };
  //     const response = await fetchCustomers(query);
  //     setCustomers(response?.customers);

  //     // Handle the response (e.g., update state for areas)
  //   } catch (error) {
  //     console.error('Error fetching customer:', error);
  //   }
  // };

  const [logisticLineOptions, setLogistics] = useState([]);

  const getLogisticLine = async () => {
    try {
      const response = await fetchLogisticLines();
      setLogistics(response?.logistic_lines || []);
    } catch (error) {
      console.error('Error fetching logistic lines:', error);
    }
  };

  const handleProductChange = async (index, e) => {
    const { name, value, selectedOptions } = e.target; //target for quantity, produtRemark
    const selectedId = selectedOptions
      ? selectedOptions[0].getAttribute('data-id')
      : null;

    // Update the product state
    const updatedProducts = [...products];
    updatedProducts[index][name] = value;
    setProducts(updatedProducts);

    // Make an API call using the selectedId
    if (selectedId) {
      try {
        const matchedProduct = productInfo.find(
          (product) => product.id === selectedId
        );

        // Update the product state with the fetched details
        updatedProducts[index] = {
          ...updatedProducts[index],
          productId: matchedProduct?.id,
          productName: matchedProduct?.name || '',
          //   unitPrice: matchedProduct?.price || '',
          specification: matchedProduct?.specification || '',
          origin: matchedProduct.origin?.name || '',
          processLocation: matchedProduct?.process_location?.name || '',
          //   quantity: matchedProduct?.quantity_per_packing_unit || '',
          // Add other fields as needed
        };
        setProducts(updatedProducts);
      } catch (error) {
        console.error('Error fetching product details:', error);
      }
    }
  };

  const productsLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const per_page = 50;
    const query = { page, per_page, search: inputValue, LOB: 1 };

    const productsResponse = await searchProducts(query);
    // setProductsInfo(productsResponse?.products || []);
    setProductsInfo((prev) => [...prev, ...(productsResponse?.products || [])]);

    const newOptions = productsResponse.products?.map((product) => ({
      value: product.code || product.name,
      label: `${product.code} - ${product.name}`,
      id: product.id,
    }));
    return {
      options: newOptions,
      hasMore:
        productsResponse.pagination.current_page <
        productsResponse.pagination.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  // const getCustomerCodes = async () => {
  //   try {
  //     const page = 1;
  //     const per_page = 100;
  //     const search = '';
  //     const query = { page, per_page, search };
  //     const response = await fetchProductDetails({ query });
  //   } catch (error) {
  //     console.error('Error fetching payment methods:', error);
  //   }
  // };

  const saveSubmit = async () => {
    if (!tmrCheck) {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinutes = now.getMinutes();

      // Check if the delivery date is tomorrow
      const deliveryDateObj = new Date(deliveryDate);
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      // Check if delivery date is tomorrow and time is after 4 PM
      if (
        deliveryDateObj.toDateString() === tomorrow.toDateString() &&
        (currentHour > 16 || (currentHour === 16 && currentMinutes > 0))
      ) {
        // Open the confirmation modal
        setConfirmationModal(true);
        return; // Stop further execution
      }
    }
    setLoader(true); // Start loading
    // Map over the products array to extract only the required fields
    const simplifiedProducts = products.map((product) => ({
      product_id: product?.productId, // Assuming productCode is the selected product ID
      quantity: product?.quantity,
      // unit_price: product?.unitPrice,
      remarks: product?.productRemark,
      discount: product?.discount,
    }));
    var data = '';
    // if (!enableInput) {
    data = {
      type: 'CATERING',
      new_info: false,
      customer_id: selectedCustomer?.id,
      payment_status_id: paymentStatus?.id,
      delivery_date: deliveryDate,
      payment_date: paymentDate,
      remark: orderRemark,
      po_number: poNumber,
      logistic_line_id: logisticLineManual.id,
      reference_number: referenceNumber,
      products: simplifiedProducts,
    };

    const response = await addOrders(data);
    if (response.success) {
      onSuccess();
      setLoader(false); // Start loading
      setAddCateringModal(false);
      showSuccessToast(response.message);
      return response;
    } else {
      setLoader(false);
    }
    // Add your save logic here
  };
  const handleModalSuccess = () => {
    setConfirmationModal(false);
    setTmrCheck(true);
    saveSubmit();
  };

  return (
    <div className="modal fade show d-block" id="add-order-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">{t('ADDNEWCATERINGORDER')}</h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => setAddCateringModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="input-main">
              <div className="row">
                {/* Delivery Date */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="date"
                      name="deliveryDate"
                      value={deliveryDate}
                      onChange={(e) => setDeliveryDate(e.target.value)}
                    />
                    <label className="delivery-label">
                      {t('DELIVERYDATE')}
                    </label>
                  </div>
                </div>

                {/* Reference Number */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="text"
                      value={referenceNumber}
                      onChange={(e) => setReferenceNumber(e.target.value)}
                    />
                    <label>{t('REFERENCENUMBER')}</label>
                  </div>
                </div>

                {/* PO Number */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="text"
                      value={poNumber}
                      onChange={(e) => setPoNumber(e.target.value)}
                    />
                    <label>{t('PONUMBER')}</label>
                  </div>
                </div>

                {/** customer code */}
                <div className="col-sm-4">
                  {/* <div className="custom-floating-group">
                    <Select
                      className="w-100"
                      value={customerCodeOptions.find(
                        (option) => option.value === selectedCustomer?.code
                      )} // Use customerCode
                      onChange={handleCustomerCodeChange} // Use the updated handler
                      options={customerCodeOptions} // Pass the transformed options
                      placeholder={t('SEARCHANDSELECTCUSTOMER')}
                      // isClearable // Allows clearing the selection
                      isSearchable // Enables search functionality
                    />
                  </div> */}
                  <AsyncPaginate
                    className="w-100"
                    value={
                      selectedCustomer?.id
                        ? {
                            value: selectedCustomer.id,
                            label: selectedCustomer.code,
                          }
                        : null
                    }
                    loadOptions={customersLoadOptions('code')}
                    onChange={handleCustomerCodeChange}
                    placeholder={t('SEARCHANDSELECTCUSTOMER')}
                    isClearable
                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {/* Customer Name */}

                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    {/* <Select
                      className="w-100"
                      value={customerNameOptions.find(
                        (option) => option.value === selectedCustomer?.code
                      )} // Use customerCode
                      onChange={handleCustomerCodeChange} // Use the updated handler
                      options={customerNameOptions} // Pass the transformed options
                      placeholder={t('SELECTCUSTOMERNAME')}
                      // isClearable // Allows clearing the selection
                      isSearchable // Enables search functionality
                    /> */}
                    <AsyncPaginate
                      className="w-100"
                      value={
                        selectedCustomer?.id
                          ? {
                              value: selectedCustomer.id,
                              label: selectedCustomer.name,
                            }
                          : null
                      }
                      loadOptions={customersLoadOptions('name')}
                      onChange={handleCustomerCodeChange}
                      placeholder={t('SEARCHANDSELECTCUSTOMER')}
                      isClearable
                      additional={{
                        page: 1,
                      }}
                    />
                  </div>
                </div>

                {/** Delivery Address */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={selectedCustomer.delivery_address}
                      onChange={(e) =>
                        handleDropdownChange('deliveryAddress', e.target.value)
                      }
                      disabled
                    >
                      <option value="">{t('SELECTDELIVERYADDRESS')}</option>
                      {customers.map((customer) => (
                        <option
                          key={customer.id}
                          value={customer.delivery_address}
                        >
                          {customer.delivery_address}
                        </option>
                      ))}
                    </select>
                    <label>{t('DELIVERYADDRESS')}</label>
                  </div>
                  {/* <button onClick={() => toggleInput(true)}>Add New</button> */}
                </div>

                {/** Area */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={selectedCustomer.area?.name}
                      onChange={(e) =>
                        handleDropdownChange('area', e.target.value)
                      }
                      disabled
                    >
                      <option value="">{t('SELECTAREA')}</option>
                      {customers.map((customer) => (
                        <option key={customer.id} value={customer.area?.name}>
                          {customer.area?.name}
                        </option>
                      ))}
                    </select>
                    <label>{t('AREA')}</label>
                  </div>
                </div>

                {/** District */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={selectedCustomer.district?.name}
                      onChange={(e) =>
                        handleDropdownChange('district', e.target.value)
                      }
                      disabled
                    >
                      <option value="">{t('SELECTDISTRICT')}</option>
                      {customers.map((customer) => (
                        <option
                          key={customer.id}
                          value={customer.district?.name}
                        >
                          {customer.district?.name}
                        </option>
                      ))}
                    </select>
                    <label>{t('DISTRICT')}</label>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={logisticLineManual.name}
                      onChange={handleLogisticLineChange}
                    >
                      <option value="">{t('SELECTLOGISTICLINE')}</option>
                      {logisticLineOptions.map((line) => (
                        <option key={line.id} value={line.name}>
                          {line.name}
                        </option>
                      ))}
                    </select>
                    <label>{t('LOGISTICLINE')}</label>
                  </div>
                </div>

                {/** Contact Person */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={selectedCustomer.contact_name}
                      onChange={(e) =>
                        handleDropdownChange('contactPerson', e.target.value)
                      }
                      disabled
                    >
                      <option value="">{t('SELECTCONTACTPERSON')}</option>
                      {customers.map((customer) => (
                        <option key={customer.id} value={customer.contact_name}>
                          {customer.contact_name}
                        </option>
                      ))}
                    </select>
                    <label>{t('CONTACTPERSON')}</label>
                  </div>
                </div>

                {/** Contact Phone */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={selectedCustomer.contact_phone}
                      onChange={(e) =>
                        handleDropdownChange('contactPhone', e.target.value)
                      }
                      disabled
                    >
                      <option value="">{t('SELECTCONTACTPHONE')}</option>
                      {customers.map((customer) => (
                        <option
                          key={customer.id}
                          value={customer.contact_phone}
                        >
                          {customer.contact_phone}
                        </option>
                      ))}
                    </select>
                    <label>{t('CONTACTPHONE')}</label>
                  </div>
                </div>

                {/* Payment Method */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={selectedCustomer.payment_method?.name}
                      onChange={(e) =>
                        handleDropdownChange('paymentMethod', e.target.value)
                      }
                      disabled
                    >
                      <option value="">{t('SELECTPAYMENTMETHOD')}</option>
                      {customers.map((customer) => (
                        <option
                          key={customer.id}
                          value={customer.payment_method?.name}
                        >
                          {customer.payment_method?.name}
                        </option>
                      ))}
                      {/* Populate options dynamically */}
                    </select>
                    <label>{t('PAYMENTMETHOD')}</label>
                  </div>
                </div>

                {/* Payment Status */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={paymentStatus.name}
                      onChange={handlePaymentStatusChange}
                    >
                      <option value="">{t('SELECTPAYMENTSTATUS')}</option>
                      {paymentOptions.map((payment_status) => (
                        <option
                          key={payment_status.id}
                          value={payment_status.name}
                        >
                          {payment_status.name}
                        </option>
                      ))}
                    </select>
                    <label>{t('PAYMENTSTATUS')}</label>
                  </div>
                </div>
                {/* Payment Date */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="date"
                      value={paymentDate}
                      onChange={(e) => setPaymentDate(e.target.value)}
                    />
                    <label>{t('PAYMENTDATE')}</label>
                  </div>
                </div>
                {/* Order Remark */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="text"
                      value={orderRemark}
                      onChange={(e) => setOrderRemark(e.target.value)}
                    />
                    <label>{t('ORDERREMARK')}</label>
                  </div>
                </div>
              </div>
            </div>
            {/* Products Section */}
            <section className="products-section">
              <h5>{t('PRODUCTSINFO')}</h5>
              <button className="btn btn-success" onClick={addProduct}>
                {t('ADDPRODUCT')}
              </button>
              <div
                className={`table-outer ${products.length > 0 ? 'scroll' : ''}`}
              >
                <table className="table">
                  <thead>
                    <tr className="t-heading">
                      <th className="id">
                        <h5>#</h5>
                      </th>
                      <th className="code">
                        <h5>{t('PRODUCTCODE')}</h5>
                      </th>
                      <th className="name">
                        <h5>{t('PRODUCTNAME')}</h5>
                      </th>
                      <th className="origin">
                        <h5>{t('ORIGIN')}</h5>
                      </th>
                      <th className="specification">
                        <h5>{t('SPECIFICATION')}</h5>
                      </th>
                      <th className="quantity">
                        <h5>{t('QUANTITY')}</h5>
                      </th>

                      <th className="remark">
                        <h5>{t('PRODUCTREMARK')}</h5>
                      </th>
                      <th className="location">
                        <h5>{t('PROCESSLOCATION')}</h5>
                      </th>
                      <th className="action">
                        {' '}
                        <h5>{t('ACTION')}</h5>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((product, index) => (
                      <tr
                        key={index}
                        className={`${!product?.isEditing && (actionType === 'Add' || actionType === 'Edit') ? 'editing' : ''}`}
                      >
                        <td className="id">{index + 1}</td>
                        <td className="code">
                          <AsyncPaginate
                            value={productInfo.find(
                              (option) =>
                                option.name === product.productCode ||
                                option.code === product.productCode
                            )}
                            loadOptions={productsLoadOptions}
                            onChange={(selectedOption) => {
                              // Handle the change event
                              const event = {
                                target: {
                                  name: 'productCode',
                                  value:
                                    selectedOption.code || selectedOption.name,
                                  selectedOptions: [
                                    { getAttribute: () => selectedOption.id },
                                  ],
                                },
                              };
                              handleProductChange(index, event);
                            }}
                            placeholder={t('SEARCHANDSELECTPRODUCT')}
                            isDisabled={!product.isEditing}
                            isClearable
                            additional={{
                              page: 1,
                            }}
                          />
                        </td>
                        <td className="name">
                          <input
                            type="text"
                            name="productName"
                            value={product.productName}
                            onChange={(e) => handleProductChange(index, e)}
                            ref={(el) =>
                              (dynamicSizeInputRefs.current[index] = el)
                            }
                            disabled
                          />
                        </td>
                        <td className="origin">
                          <input
                            type="text"
                            name="origin"
                            value={product.origin}
                            onChange={(e) => handleProductChange(index, e)}
                            disabled
                          />
                        </td>
                        <td className="specification">
                          <input
                            type="text"
                            name="specification"
                            value={product.specification}
                            onChange={(e) => handleProductChange(index, e)}
                            disabled
                            ref={(el) =>
                              (specificationInputRefs.current[index] = el)
                            }
                          />
                        </td>
                        <td className="quantity">
                          <input
                            type="number"
                            name="quantity"
                            value={product.quantity}
                            onChange={(e) => handleProductChange(index, e)}
                          />
                        </td>

                        <td className="remark">
                          <input
                            type="text"
                            name="productRemark"
                            value={product.productRemark}
                            onChange={(e) => handleProductChange(index, e)}
                            ref={(el) =>
                              (productRemarkInputRefs.current[index] = el)
                            }
                          />
                        </td>
                        <td className="location">
                          <input
                            type="text"
                            name="processLocation"
                            value={product.processLocation}
                            onChange={(e) => handleProductChange(index, e)}
                            disabled
                          />
                        </td>
                        <td className="action">
                          <div className="d-flex gap-1">
                            {actionType === 'Edit' && (
                              <button
                                className="btn btn-primary"
                                onClick={() => toggleEdit(index)}
                              >
                                <img src="images/green-edit.svg" alt="Edit" />
                              </button>
                            )}
                            <button
                              className="btn btn-danger"
                              onClick={() => removeProduct(index)}
                            >
                              <img src="images/red-delete.svg" alt="" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
            {/* Bottom buttons */}
            <div className="bottom-button">
              <button
                className="cancel"
                onClick={() => setAddCateringModal(false)}
                disabled={loader}
              >
                {t('CANCEL')}
              </button>
              <button
                className="save"
                onClick={() => saveSubmit()}
                disabled={loader}
              >
                {loader && (
                  <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                  </div>
                )}
                {t('SAVE')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={confirmationModal}
        onRequestClose={() => setConfirmationModal(false)}
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        overlayClassName={`modal-overlay add `}
        portalClassName="add view-modal cutoff"
      >
        <ConfirmationModal
          type={'catering'}
          setConfirmationModal={setConfirmationModal}
          selectedOrdersEdit={''}
          actionType={'Add'}
          onSuccess={handleModalSuccess}
        />
      </Modal>
    </div>
  );
};

export default AddCateringModal;
